import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { onMounted } from 'vue';
import { TagDto, TagService } from '@/api';
import Tag from '@/components/tags/Tag.vue';
import { VAutocomplete } from 'vuetify/lib';

interface TagSelectorProps {
  filterMode?: boolean;
  returnObject?: boolean;
}
type TagSelectorEmits = {
  (event: 'input', tags: TagDto[] | string[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tag-Selector',
  props: {
  filterMode: { type: Boolean, default: false },
  returnObject: { type: Boolean, default: true },
  value: null
},
  emits: ["input"],
  setup(__props, { emit: emits }) {

const props = __props;




const { value: selectedTags } = __MACROS_useVModel(["value", undefined, "input"]);

let fetchedTags = _ref<TagDto[]>([]);
let loading = _ref(false);
let searchString = _ref('');
const tagSelector = _ref<{ blur:() => void } | null>(null);

const mustReturnObject = _computed(() => (props.filterMode ? false : props.returnObject !== false));
const isFilterMode = _computed(() => props.filterMode);
const innerIcon = _computed(() => (props.filterMode ? 'icon-tag' : ''));

/**
 * Get different item icon based on content value
 * @param hasValue true if not empty
 */
const customItemIcon = (hasValue: boolean) => (hasValue ? 'icon-check-square-fill' : 'icon-check-square-outline-empty');

/**
 * Close v-autocomplete dropdown
 */
const closeMenu = () => {
  tagSelector.value?.blur();
};

/**
 * Fetch complete tag data
 */
 const fetchTags = async () => {
  loading.value = true;
  const { data } = await TagService.getAllTag({ itemsPerPage: -1 });
  fetchedTags.value = data;
  loading.value = false;
};

/**
 * Clear selected tags & fetched data
 */
 const clear = () => {
  selectedTags.value = [];
  searchString.value = '';
  emits('input', selectedTags.value);
  closeMenu();
};

/**
 * Helper function for v-autocomplete item-value
 * @param item tag item
 */
const getItemValue = (item: TagDto): TagDto | string => (isFilterMode.value ? item.id : item);

/**
 * Check if tooltip should be shown for given item
 * @param item tag item name
 */
 const shouldShowTooltip = (item: string) => item.length >= 20;

/**
 * Computes display values for the selected tags based on filter mode
 * @returns a list of tag IDs (strings) or tag objects (TagDto) based on current selection and filter mode
 */
const displayTags = _computed<(string | TagDto)[]>({
  get: () => {
    const tags = selectedTags.value;

    if (!tags) return [];

    if (isFilterMode.value && tags.every((t): t is string => typeof t === 'string')) {
      return tags;
    }

    if (!isFilterMode.value && tags.every((t): t is TagDto => typeof t === 'object')) {
      return tags.map(getItemValue);
    }

    return [];
  },
  set: (newValues: (string | TagDto)[]) => {
    if (!newValues) return;

    if (isFilterMode.value) {
      selectedTags.value = newValues
        .map((id) => fetchedTags.value.find((tag) => tag.id === id))
        .filter((tag): tag is TagDto => !!tag);
    } else {
      selectedTags.value = newValues as TagDto[];
    }
  },
});

onMounted(() => {
  fetchTags();
});

return { __sfc: true,props, emits, selectedTags, fetchedTags, loading, searchString, tagSelector, mustReturnObject, isFilterMode, innerIcon, customItemIcon, closeMenu, fetchTags, clear, getItemValue, shouldShowTooltip, displayTags, _ref, _computed, __MACROS_useVModel, onMounted, TagDto, TagService, Tag, VAutocomplete }
}

})